import { NotificationService } from 'src/app/shared/services/notification.service';
import { UserRole } from './../../follow-ups/models/deviation';
import { inject, Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SelectItem, ConfirmationService } from 'primeng/api';

import { BaseServices } from './../../kuba.services';
import { Options } from './../../../_models/options';
import { Rights, Roles, Status } from './../../../_models/feature';
import { HelperService } from './../../../_services/helper.service';
import { DatePickerOptions } from './../../../_helpers/date-setting';
import { EmployeeLeaveService } from '../services/employeeleave.service';
import { EmployeeHoliday, EmployeeLeave, UserRights } from '../models/index';
import { TranslateService } from '@ngx-translate/core';
import { BusinessServices } from 'src/app/kuba/businesses/services/business.services';
import { combineLatest, forkJoin, Observable, Subscription } from 'rxjs';
import { DateService } from 'src/app/_services/date.service';
import { finalize, map, startWith, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { chargeableLeaveDates, leaveDate } from '../services/leave-calendar';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'leave-edit',
  templateUrl: 'employee-leave-edit.component.html',
  standalone: false
})
export class LeaveEditComponent implements OnInit {
  isUser: boolean = false;
  //#region  variables

  private readonly notifications = inject(NotificationService);
  empId: number;
  isHiddenEndDate = true;
  isGridHidden = false;
  Year: any = [];
  approvalPersons: SelectItem[];
  leaveForm: FormGroup;
  isMypage = true;
  isVisible = false;
  isApprovalPerson = false;
  parentKey: string;
  leaveId: number;
  isHidden = false;
  employeeLeave: EmployeeLeave[];
  IsShowWeekend = false;
  locale = 'en';
  isApproved = false;
  leaveAlerttext: string;
  isLeaveAvailable: boolean;
  leaveApprovalPerson: number;
  statusChangeByUser = false;
  leaveSaveByUser = false;
  loading = false;
  leaveAvailableId: number;
  isLeaveExist = false;
  additionalData: any;
  isNotUser: boolean;
  totalDates: any = [];
  formattedTotalDates = [];
  isNoAvailableLeave: boolean;
  editOwnStatus: boolean;
  isLeaveGreaterThanNoofDays: boolean;
  isFromDateGreaterThanEndDate: boolean;
  editStatus: boolean;
  selectedYear: any;
  startDate: any;
  endDate: any;
  totalDays: number;
  map = new Map<any, any>();
  workingModule: any;
  isApprovalPerson1 = true;
  LeaveList: any = [];
  ApprovalPerson: any;
  leaveStatus: boolean;

  options = [
    new Options(Status.Open, 'OPEN'),
    new Options(Status.Approved, 'APPROVED'),
    new Options(Status.Rejected, 'REJECTED')
  ];

  protected holidays$: Observable<EmployeeHoliday[]>;
  protected holidays: Date[] = [];

  private subscriptions: Subscription[] = [];
  /**
   * Date picker configuration option
   */
  public startDateOptions: DatePickerOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableWeekends: !this.IsShowWeekend,
    editableDateField: false,
    openSelectorOnInputClick: true,
    firstDayOfWeek: 'su',
    satHighlight: true,
    height: '26px',
    selectionTxtFontSize: '14px',
    disableSince: this.getStartDate(),
    todayBtnTxt: this.translate.instant('TODAY'),
    dayLabels: {
      su: this.translate.instant('SUN'),
      mo: this.translate.instant('MON'),
      tu: this.translate.instant('TUE'),
      we: this.translate.instant('WED'),
      th: this.translate.instant('THU'),
      fr: this.translate.instant('FRI'),
      sa: this.translate.instant('SAT')
    },
    monthLabels: {
      1: this.translate.instant('JANUARY'),
      2: this.translate.instant('FEBRUARY'),
      3: this.translate.instant('MARCH'),
      4: this.translate.instant('APRIL'),
      5: this.translate.instant('MAY'),
      6: this.translate.instant('JUNE'),
      7: this.translate.instant('JULY'),
      8: this.translate.instant('AUGUST'),
      9: this.translate.instant('SEPTEMBER'),
      10: this.translate.instant('OCTOBER'),
      11: this.translate.instant('NOVEMBER'),
      12: this.translate.instant('DECEMBER')
    },
    disableUntil: this.getEndDate(),
    disableDays: this.getHolidayList()
  };
  public endDateOptions: DatePickerOptions = this.startDateOptions;
  userRights: any;
  Approver: any;
  EditLeaveValue: any;
  ApproverRights: boolean;
  isEditor: boolean = true;
  isGuest: boolean;

  //#endregion

  //#region constructor
  /**
   * constructor
   * @param _fb {FormBuilder}
   * @param emplevsrvc {EmployeeLeaveService}
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   * @param location {Location}
   */
  constructor(
    private _fb: FormBuilder,
    public employeeLeaveService: EmployeeLeaveService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private location: Location,
    private translate: TranslateService,
    private businessservice: BusinessServices,
    private dateService: DateService,
    private messageService: MessageService
  ) {}
  //#endregion

  //#region page-events

  /**
   * getting the employee id,setting form group,getting employee data by passing employee id,
   * binding approval person dropdown
   */
  // TODO: to be implemented leave approval function based on thet form to be disabled
  ngOnInit() {
    this.workingModule = JSON.parse(sessionStorage.getItem('workingModule')!);
    document.querySelector('body').classList.remove('opened');
    this.isNotUser = +BaseServices.roleId === UserRole.USER ? false : true;
    this.isUser = +BaseServices.roleId === UserRole.USER ? true : false;
    this.isEditor = +BaseServices.roleId === UserRole.EDITOR ? true : false;
    this.isGuest = +BaseServices.roleId === UserRole.GUEST ? true : false;

    if (this.isGuest == true) {
      this.ApproverRights = false;
    }
    this.Year = [];
    let year = new Date();
    // binding the year dropdown
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Year = [];
        this.Year.push({ label: val.SELECT, value: null });
        this.Year.push({
          label: year.getFullYear() - 1,
          value: year.getFullYear() - 1
        });
        this.Year.push({
          label: year.getFullYear(),
          value: year.getFullYear()
        });
        this.Year.push({
          label: year.getFullYear() + 1,
          value: year.getFullYear() + 1
        });
      })
    );
    let eid = this.route.snapshot.params['eid'];
    if (eid) {
      this.empId = +eid;
    }
    this.leaveForm = this._fb.group({
      IsShowWeekend: [false],
      NoOfDays: [''],
      startDate: new FormControl<Date | null>(null, Validators.required),
      endDate: new FormControl<Date | null>(null, Validators.required),
      ApprovalPerson: [],
      ApprovalPersonList: [[], Validators.required],
      Description: [''],
      LeaveTaken: ['0'],
      LeaveToBeAvailed: [''],
      Year: [''],
      AvailableLeave: [''],
      Status: [Status.Open]
    });

    if (
      BaseServices.checkUserRights(Rights.APPROVE_LEAVE, BaseServices.UserRole)
    ) {
      this.isApprovalPerson = true;
      this.ApproverRights = true;
    } else {
      this.isApprovalPerson = false;
      this.ApproverRights = false;
    }

    if (BaseServices.roleId == Roles.EDITOR.toString()) {
      this.ApproverRights = true;
    }

    let leave = this.route.snapshot.data['edit'];
    if (leave) {
      this.employeeLeave = leave;
    }
    let key = this.route.snapshot.data['parent'];
    if (key) {
      this.parentKey = key;
    }
    this.binddetails();
    if (this.parentKey === 'LEAVE') {
      this.isHidden = true;
      this.isGridHidden = true;
      this.isMypage = true;
      this.isVisible = false;
      this.isLeaveExist = false;
      let data = this.route.snapshot.data['leaveEdit'];
      if (data) {
        let currentUserRole = BaseServices.UserRole;
        let userRightsId = Rights.APPROVE_LEAVE;
        let rights = BaseServices.checkUserRights(
          userRightsId,
          currentUserRole
        );
        if (rights === true) {
          this.isApprovalPerson1 = false;
        }
        this.leaveAvailableId = data.LeaveAvailableId;
        if (data.Status === Status.Approved) {
          this.isApproved = true;
        }
        this.initForm(data, null);
      }
    } else if (this.parentKey === 'EMPLOYEE') {
      this.isHidden = false;
      this.isVisible = true;
      this.isGridHidden = false;
      this.isMypage = true;
      //  this.leaveAvailabilityCheck();no need to calculate leave availability at the page load
    } else if (this.parentKey === 'MYPAGE') {
      // my page routing not coming from anywhere, non usable code
      this.isHidden = true;
      this.isVisible = true;
      this.isMypage = false;
      this.isGridHidden = false;
    }
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.LEAVE_LIST,
          header: 'Leave List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Employee Name', dataKey: 'EmployeeName' },
            { title: 'Start Date', dataKey: 'StartDate' },
            { title: 'End Date', dataKey: 'EndDate' },
            { title: 'No Of Days', dataKey: 'NoOfDays' },
            { title: 'Status', dataKey: 'StatusText' },
            { title: 'Approver', dataKey: 'ApprovalPersonName' },
            { title: 'Description', dataKey: 'Description' }
          ]
        };
      })
    );

    this.holidays = (this.route.snapshot.data['holiday'] ?? [])
      .map(holiday => leaveDate(holiday.HolidayDate))
      .filter((date): date is Date => date !== null);
    this.initNumberOfDaysField();
  }

  /**
   * init form
   * @param data {any}
   */
  initForm(data: any, approvalList: any) {
    let id = this.route.snapshot.params['lid'];
    if (id) {
      this.leaveId = id;
    }
    let startDate;
    let endDate;
    let leaveTaken: 0;
    if (data) {
      this.EditLeaveValue = { ...data };
      if (!data.ApprovalPersonList && approvalList) {
        data.ApprovalPersonList = approvalList['ApprovalPersonList'];
      }
      this.isLeaveExist = true;
      this.empId = data.EmployeeId;
      this.leaveApprovalPerson = data.ApprovalPerson ? data.ApprovalPerson : 0;
      this.bindControls(data);
      this.isHiddenEndDate = false;
      startDate = HelperService.formatInputDate(
        data.StartDate ? data.StartDate : null
      );
      if (data.EmployeeId === BaseServices.FeatureKey) {
        this.startDateOptions.disableSince = this.getStartDate();
        this.startDateOptions.disableUntil = this.getEndDate();
      }

      // End Date Input and Date Range set
      endDate = HelperService.formatInputDate(
        data.EndDate ? data.EndDate : null
      );
      this.endDateOptions.disableUntil = {
        year: startDate.date.year,
        month: startDate.date.month,
        day: startDate.date.day
      };
      this.endDateOptions.disableSince = {
        year: startDate.date.year + 1,
        month: 1,
        day: 1
      };
      leaveTaken = data.LeaveTaken ? data.LeaveTaken : 0;
      let leaveDetails;
      this.IsShowWeekend = data.IsShowWeekend === true ? true : false;
      this.changeSettings();
      leaveDetails = {
        startDate: data.StartDate ? leaveDate(data.StartDate) : null,
        endDate: data.EndDate ? leaveDate(data.EndDate) : null,
        LeaveToBeAvailed: data.LeaveAvailable,
        LeaveTaken: leaveTaken,
        ApprovalPerson: data.ApprovalPerson,
        ApprovalPersonList: data.ApprovalPersonList,
        Description: data.Description,
        NoOfDays: data.NoOfDays,
        Year: data.Year,
        IsShowWeekend: data.IsShowWeekend,
        AvailableLeave: '',
        Status: data.Status
      };

      this.leaveForm.setValue(leaveDetails);

      if (this.empId > 0) {
        let availableLeave = data.LeaveAvailable - data.LeaveTaken;
        this.leaveForm.get('LeaveToBeAvailed')!.patchValue(data.LeaveAvailable);
        this.leaveForm.get('AvailableLeave')!.patchValue(availableLeave);
        this.leaveForm.get('LeaveTaken')!.patchValue(leaveTaken);
        this.leaveForm.get('LeaveTaken')!.patchValue(leaveTaken);
        this.leaveForm.get('Year')!.patchValue(data.Year ?? startDate.date.year);
      }
    }
  }

  initNumberOfDaysField() {
    this.subscriptions.push(
      combineLatest([
        this.leaveForm
          .get('startDate')
          .valueChanges.pipe(startWith(this.leaveForm.get('startDate').value)),
        this.leaveForm
          .get('endDate')
          .valueChanges.pipe(startWith(this.leaveForm.get('endDate').value)),
        this.leaveForm
          .get('IsShowWeekend')
          .valueChanges.pipe(
            startWith(this.leaveForm.get('IsShowWeekend').value)
          )
      ]).subscribe(() => this.recalculateDays())
    );
  }

  private recalculateDays() {
    if (!this.leaveForm) return;
    const { startDate, endDate, IsShowWeekend } = this.leaveForm.getRawValue();
    const first = leaveDate(startDate);
    const last = leaveDate(endDate);
    this.isFromDateGreaterThanEndDate = !!first && !!last && first > last;
    const days = chargeableLeaveDates(
      startDate,
      endDate,
      IsShowWeekend === true,
      this.holidays
    );
    this.leaveForm.get('NoOfDays').setValue(days.length, { emitEvent: false });
  }

  /**
   * give rights to save
   * @param data {any}
   */
  bindControls(data: any) {
    if (
      data.ApprovalPerson === BaseServices.UserId ||
      parseInt(BaseServices.roleId) == 3
    ) {
      this.editOwnStatus = true;
      this.isApprovalPerson = false;
      this.leaveSaveByUser = true;
      if (data.EmployeeId !== data.ApprovalPerson) {
        if (this.parentKey === 'EMPLOYEE') {
          this.editOwnStatus = true;
          this.isApprovalPerson = false;
          this.leaveSaveByUser = true;
        } else {
          this.isApprovalPerson = true;
          this.statusChangeByUser = true;
          this.leaveSaveByUser = true;
          this.editOwnStatus = false;
          this.editStatus = true;
        }
      }
    } else if (data.EmployeeId === BaseServices.FeatureKey) {
      this.isApprovalPerson = false;
      this.editOwnStatus = false;
      this.statusChangeByUser = false;
      this.leaveSaveByUser = true;
    } else {
      this.isApprovalPerson = true;
      this.statusChangeByUser = true;
      this.leaveSaveByUser = false;
    }

    let userRightsId = Rights.APPROVE_LEAVE;
    let role = BaseServices.UserRole;
    if (role === 'User') {
      let checkUserRights = BaseServices.checkUserRights(userRightsId, role);
      if (checkUserRights) {
        this.isApprovalPerson = false;
        this.leaveSaveByUser = true; //KW-1058:Enable save button for User with approval rights
      }
      if (this.workingModule.id == 8) {
        if (
          data.ApprovalPersonList.some((e: any) => e === BaseServices.UserId)
        ) {
          this.leaveSaveByUser = true;
        } else {
          this.leaveSaveByUser = false;
        }
      }
    }
    if (role === 'Editor') {
      let checkUserRights = BaseServices.checkUserRights(userRightsId, role);
      if (checkUserRights) {
        this.isApprovalPerson = false;
        this.leaveSaveByUser = true; //KW-1058:Enable save button for Editor with approval rights
      }
    }
  }

  //#endregion

  //#region control-events

  /**
   * Save and update employee leave
   */
  onSubmit(mode: string) {
    if (this.loading) return;
    this.recalculateDays();
    this.leaveForm.markAllAsTouched();
    const form = this.leaveForm.getRawValue();
    if (
      this.leaveForm.invalid ||
      !leaveDate(form.startDate) ||
      !leaveDate(form.endDate) ||
      this.isFromDateGreaterThanEndDate ||
      (form.NoOfDays <= 0 && form.Status !== Status.Rejected)
    )
      return;

    const leave = new EmployeeLeave();
    leave.Id = +this.leaveId || 0;
    leave.EmployeeId = this.empId;
    leave.StartDate = this.dateService.formatDateToString(form.startDate);
    leave.EndDate = this.dateService.formatDateToString(form.endDate);
    leave.NoOfDays = form.NoOfDays;
    leave.Year = form.startDate.getFullYear();
    leave.Status = leave.Id > 0 ? +form.Status : Status.Open;
    leave.ApprovalPerson = form.ApprovalPerson ? +form.ApprovalPerson : null;
    leave.ApprovalPersonList = (form.ApprovalPersonList ?? []).map(Number);
    leave.Description = form.Description;
    leave.IsShowWeekend = form.IsShowWeekend === true;
    leave.LanguageId = BaseServices.userLanguageId;
    leave.BusinessId = BaseServices.BusinessId;
    leave.UserId = BaseServices.UserId;

    this.loading = true;
    this.subscriptions.push(
      this.validateLeaveAvailability(leave)
        .pipe(
          switchMap(valid =>
            valid
              ? leave.Id > 0
                ? this.employeeLeaveService.update(leave)
                : this.employeeLeaveService.add(leave)
              : EMPTY
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: result => {
            if (!result) return;
            this.getEmployee(this.empId);
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            if (mode === 'SAVE') this.onClear();
            else this.gotoList();
          },
          error: () => {
            /* The HTTP interceptor displays the error; keep the edit ID and form for retry. */
          }
        })
    );
  }

  private validateLeaveAvailability(leave: EmployeeLeave): Observable<boolean> {
    if (leave.Status === Status.Rejected) return of(true);
    const requestedDates = chargeableLeaveDates(
      leave.StartDate,
      leave.EndDate,
      leave.IsShowWeekend,
      this.holidays
    );
    const years = [...new Set(requestedDates.map(date => date.getFullYear()))];
    if (years.length === 0) return of(false);
    const original = this.EditLeaveValue;
    const previousDates =
      original?.Id === leave.Id && original?.Status === Status.Approved
        ? chargeableLeaveDates(
            original.StartDate,
            original.EndDate,
            original.IsShowWeekend === true,
            this.holidays
          )
        : [];
    return forkJoin(
      years.map(year =>
        this.employeeLeaveService.getAvailableLeaves(
          this.empId,
          BaseServices.BusinessId,
          year
        )
      )
    ).pipe(
      map(results => {
        for (let index = 0; index < years.length; index++) {
          const year = years[index];
          const allocation = results[index] as any;
          const requested = requestedDates.filter(
            date => date.getFullYear() === year
          ).length;
          const previous = previousDates.filter(
            date => date.getFullYear() === year
          ).length;
          const available =
            (allocation?.LeaveAvailable ?? 0) -
            (allocation?.TotalLeaveTaken ?? 0) +
            previous;
          if (!allocation || available < requested) {
            this.notifications.add({
              severity: 'error',
              detail: this.translate.instant(
                !allocation
                  ? 'EMPLOYEES_LEAVE_ERROR.NO_LEAVE_ALLOCATION'
                  : 'EMPLOYEES_LEAVE_ERROR.INSUFFICIENT_LEAVE',
                { year }
              )
            });
            return false;
          }
        }
        return true;
      })
    );
  }

  /**
   * edit employee leave
   * @param Id {number}
   */
  editLeave(data: any) {
    let Id = data['Id'];
    this.isApprovalPerson = true;
    this.subscriptions.push(
      this.employeeLeaveService
        .getEmployeeLeaveByLeaveId(Id)
        .subscribe((leave: any) => {
          if (leave) {
            this.leaveForm.reset();
            this.initForm(leave, data);
          }
          this.leaveId = leave.Id;
        })
    );
  }

  /**
   * Method used to show weekend in calender and changes in calculation
   */
  changeSettings() {
    this.IsShowWeekend = this.leaveForm.get('IsShowWeekend').value === true;
    this.recalculateDays();
  }

  /**
   * delete employee leave
   * @param id {number}
   */
  delete(id: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.employeeLeaveService
            .deleteLeave(id)
            .subscribe(deleteResponse => {
              if (deleteResponse) {
                this.getEmployee(this.empId);
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }

  /**
   * Clearing the data in form
   */
  onClear() {
    this.leaveId = 0;
    this.EditLeaveValue = null;
    this.isApprovalPerson = false;
    this.leaveForm.reset({
      IsShowWeekend: false,
      Status: Status.Open,
      ApprovalPersonList: []
    });
    this.isHiddenEndDate = true;
    this.IsShowWeekend = false;
    this.isFromDateGreaterThanEndDate = false;
    this.isLeaveGreaterThanNoofDays = false;
    this.leaveForm.get('LeaveToBeAvailed')!.patchValue('');
    this.leaveForm.get('AvailableLeave')!.patchValue('');
  }

  /**
   * Bact to list event
   */
  gotoList() {
    this.location.back();
  }

  onYearChange(e: any) {
    this.selectedYear = e.value;
    this.subscriptions.push(
      this.employeeLeaveService
        .getAvailableLeaves(this.empId, BaseServices.BusinessId, e.value)
        .subscribe((availableLeaves: any) => {
          if (availableLeaves) {
            let availableLeave =
              availableLeaves.LeaveAvailable - availableLeaves.TotalLeaveTaken;
            this.leaveForm
              .get('LeaveToBeAvailed')!
              .patchValue(availableLeaves.LeaveAvailable);
            this.leaveForm.get('AvailableLeave')!.patchValue(availableLeave);
            this.leaveForm
              .get('LeaveTaken')!
              .patchValue(availableLeaves.TotalLeaveTaken);
          } else {
            this.leaveForm.get('LeaveToBeAvailed')!.patchValue(0);
            this.leaveForm.get('AvailableLeave')!.patchValue(0);
            this.leaveForm.get('LeaveTaken')!.patchValue(0);
          }
        })
    );
    // this.leaveForm.get('NoOfDays').patchValue(this.map.get(this.selectedYear));
  }

  /**
   * event handler for End date
   * @param event {any}
   */
  getStartDate() {
    let startDate = new Date();
    return {
      year: startDate.getFullYear() + 2,
      month: 1,
      day: 1
    };
  }

  getEndDate() {
    let endDate = new Date();
    return {
      year: endDate.getFullYear() - 1,
      month: 1,
      day: 1
    };
  }

  /**
   * getting employee data by passing employee id
   * @param empid {number}
   */
  getEmployee(empId: number) {
    this.subscriptions.push(
      this.employeeLeaveService
        .getEmployeeLeavesByEmployeeId(empId)
        .subscribe((employeeLeaves: any) => {
          this.employeeLeave = employeeLeaves;
          // this.LeaveList = this.employeeLeave;
          this.LeaveList.push(this.employeeLeave);
          this.loading = false;
        })
    );
  }

  /**
   * binding approval person dropdown
   */
  binddetails() {
    this.approvalPersons = [];
    const approvalPerson = this.route.snapshot.data['approvalperson']; // Check spelling!

    if (approvalPerson && Array.isArray(approvalPerson)) {
      approvalPerson.forEach((person: any) => {
        if (person) {
          let userRights: UserRights[] = null;

          // Handle cases where Rights is "undefined", null, or invalid
          if (
            person.Rights &&
            typeof person.Rights === 'string' &&
            person.Rights !== 'undefined'
          ) {
            try {
              userRights = JSON.parse(person.Rights);
            } catch (e) {
              userRights = null;
            }
          }

          const hasAccess = HelperService.ApprovalPersonRightsCheck(
            userRights,
            Rights.APPROVE_LEAVE
          );
          if (hasAccess) {
            this.approvalPersons.push({
              label: person.Name,
              value: person.Id
            });
          }
        }
      });
    }
  }

  getHolidayList() {
    let result: Date[] = [];
    this.subscriptions.push(
      this.employeeLeaveService
        .getAllHolidays(BaseServices.BusinessId)
        .subscribe(hList => {
          hList.forEach(element => {
            var hDate = leaveDate(element['HolidayDate']);
            // Push native Date object for p-calendar compatibility
            if (hDate) result.push(hDate);
          });
          this.holidays = result;
          this.recalculateDays();
        })
    );
    return result;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
